module.exports = __webpack_public_path__ + "img/logo.30d0e56f.png";